import React, { useEffect, useState } from 'react'
import ShowCandidates from '../Candidates/showCandidates'
import Navbar from '../Common/Navbar'
import CreateEvent from '../Events/createEvent'
import ExistEvent from '../Events/existEvents'
import JobOrder from '../JobOrder/jobOrder'
import ViewJobOrder from '../JobOrder/viewJobOrder'
import ShowReports from '../Reports'
import Settings from '../Settings'
import { useHistory } from 'react-router-dom'
import Company from '../Company'
import { BUILD_DATE, OPEN_CATS_URL, VERSION } from '../../config'
import Contact from '../Contact'
import List from '../List'
import CareerReports from '../CareerReports'
import ClientSubmit from '../ClientSubmit'
import Vendor from '../Vendor'
import { toast } from 'react-toastify'
import Dashboard from '../Dashboard'

export default function Home() {

    const history = useHistory()
    // eslint-disable-next-line
    const [showDropdowns, setShowDropdowns] = useState(false);


    const CustomToast = ({ message }) => (
        <div>
            {message}{' '}
            <a href="/" rel="noopener noreferrer">
                Click here
            </a>
        </div>
    );

    const getVersion = (req, res) => {
        fetch(`${OPEN_CATS_URL}/checkVersion`)
            .then((response) => response.json())
            .then((result) => {
                if (result.version !== VERSION) {
                    toast.info(<CustomToast message="New Version Available!" />, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    });
                }
            })
    }

    useEffect(() => {
        // Function to be executed every 10 minutes
        getVersion()
        let waitTime = 10 * 60 * 1000;
        const intervalId = setInterval(getVersion, waitTime);

        // Clean up the interval when the component unmounts
        return () => {
            clearInterval(intervalId);
        };
    }, []);



    const [logEvent, setLogEvent] = useState(false)
    const [existEvents, setExistEvents] = useState(false)
    const [jobOrder, setJobOrder] = useState(false)
    const [message, setMessage] = useState()
    const [showJobOrder, setShowJobOrder] = useState(false)
    const [showCandidates, setShowCandidates] = useState(false)
    const [showReports, setShowReports] = useState(false)
    const [showSettings, setShowSettings] = useState(false)
    const [access, setAccess] = useState(0)
    const [showCompany, setShowCompany] = useState(false)
    const [showContact, setShowContact] = useState(false)
    const [showList, setShowList] = useState(false)
    const [showCareers, setShowCareers] = useState(false)
    const [showClientSubmit, setShowClientSubmit] = useState(false)
    const [showVendor, setShowVendor] = useState(false)
    const [dashboard, setDashboard] = useState(false)
    const [isNavCollapsed, setIsNavCollapsed] = useState(true);
    const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

    useEffect(() => {
        setTimeout(() => {
            setMessage("")
        }, 5000)
    }, [message])

    const handleNewEvent = () => {
        setLogEvent(true)
        setExistEvents(false)
        setJobOrder(false)
        setShowJobOrder(false)
        setShowCandidates(false)
        setShowReports(false)
        setShowSettings(false)
        setShowCompany(false)
        setShowContact(false)
        setShowList(false)
        setShowCareers(false)
        setShowClientSubmit(false)
        setShowVendor(false)
        setDashboard(false)

    }

    const handleExistEvent = () => {
        setExistEvents(true)
        setLogEvent(false)
        setJobOrder(false)
        setShowJobOrder(false)
        setShowCandidates(false)
        setShowReports(false)
        setShowSettings(false)
        setShowCompany(false)
        setShowContact(false)
        setShowList(false)
        setShowCareers(false)
        setShowClientSubmit(false)
        setShowVendor(false)
        setDashboard(false)

    }

    const handleJobOrder = () => {
        setJobOrder(true)
        setLogEvent(false)
        setExistEvents(false)
        setShowJobOrder(false)
        setShowCandidates(false)
        setShowReports(false)
        setShowSettings(false)
        setShowCompany(false)
        setShowContact(false)
        setShowList(false)
        setShowCareers(false)
        setShowClientSubmit(false)
        setShowVendor(false)
        setDashboard(false)

    }

    const handleShowJobOrder = () => {
        setShowJobOrder(true)
        setJobOrder(false)
        setLogEvent(false)
        setExistEvents(false)
        setShowCandidates(false)
        setShowReports(false)
        setShowSettings(false)
        setShowCompany(false)
        setShowContact(false)
        setShowList(false)
        setShowCareers(false)
        setShowClientSubmit(false)
        setShowVendor(false)
        setDashboard(false)

    }

    const handleShowCandidates = () => {
        setShowCandidates(true)
        setShowJobOrder(false)
        setJobOrder(false)
        setLogEvent(false)
        setExistEvents(false)
        setShowReports(false)
        setShowSettings(false)
        setShowCompany(false)
        setShowContact(false)
        setShowList(false)
        setShowCareers(false)
        setShowClientSubmit(false)
        setShowVendor(false)
        setDashboard(false)

    }

    const handleReports = () => {
        setShowCandidates(false)
        setShowJobOrder(false)
        setJobOrder(false)
        setLogEvent(false)
        setExistEvents(false)
        setShowReports(true)
        setShowSettings(false)
        setShowCompany(false)
        setShowContact(false)
        setShowList(false)
        setShowCareers(false)
        setShowClientSubmit(false)
        setShowVendor(false)
        setDashboard(false)

    }

    const handleSettings = () => {
        setShowCandidates(false)
        setShowJobOrder(false)
        setJobOrder(false)
        setLogEvent(false)
        setExistEvents(false)
        setShowReports(false)
        setShowSettings(true)
        setShowCompany(false)
        setShowContact(false)
        setShowList(false)
        setShowCareers(false)
        setShowClientSubmit(false)
        setShowVendor(false)
        setDashboard(false)

    }

    const handleCompany = () => {
        setShowCandidates(false)
        setShowJobOrder(false)
        setJobOrder(false)
        setLogEvent(false)
        setExistEvents(false)
        setShowReports(false)
        setShowSettings(false)
        setShowCompany(true)
        setShowContact(false)
        setShowList(false)
        setShowCareers(false)
        setShowClientSubmit(false)
        setShowVendor(false)
        setDashboard(false)

    }

    const handleContact = () => {
        setShowCandidates(false)
        setShowJobOrder(false)
        setJobOrder(false)
        setLogEvent(false)
        setExistEvents(false)
        setShowReports(false)
        setShowSettings(false)
        setShowCompany(false)
        setShowContact(true)
        setShowList(false)
        setShowCareers(false)
        setShowClientSubmit(false)
        setShowVendor(false)
        setDashboard(false)

    }

    const handleList = () => {
        setShowCandidates(false)
        setShowJobOrder(false)
        setJobOrder(false)
        setLogEvent(false)
        setExistEvents(false)
        setShowReports(false)
        setShowSettings(false)
        setShowCompany(false)
        setShowContact(false)
        setShowList(true)
        setShowCareers(false)
        setShowClientSubmit(false)
        setShowVendor(false)
        setDashboard(false)

    }

    const handleCareers = () => {
        setShowCandidates(false)
        setShowJobOrder(false)
        setJobOrder(false)
        setLogEvent(false)
        setExistEvents(false)
        setShowReports(false)
        setShowSettings(false)
        setShowCompany(false)
        setShowContact(false)
        setShowList(false)
        setShowCareers(true)
        setShowClientSubmit(false)
        setShowVendor(false)
        setDashboard(false)

    }

    const handleClientSubmit = () => {
        setShowCandidates(false)
        setShowJobOrder(false)
        setJobOrder(false)
        setLogEvent(false)
        setExistEvents(false)
        setShowReports(false)
        setShowSettings(false)
        setShowCompany(false)
        setShowContact(false)
        setShowList(false)
        setShowCareers(false)
        setShowClientSubmit(true)
        setShowVendor(false)
        setDashboard(false)

    }

    const handleVendor = () => {
        setShowCandidates(false)
        setShowJobOrder(false)
        setJobOrder(false)
        setLogEvent(false)
        setExistEvents(false)
        setShowReports(false)
        setShowSettings(false)
        setShowCompany(false)
        setShowContact(false)
        setShowList(false)
        setShowCareers(false)
        setShowClientSubmit(false)
        setShowVendor(true)
        setDashboard(false)

    }

    const handleDashboard = () => {
        setShowCandidates(false)
        setShowJobOrder(false)
        setJobOrder(false)
        setLogEvent(false)
        setExistEvents(false)
        setShowReports(false)
        setShowSettings(false)
        setShowCompany(false)
        setShowContact(false)
        setShowList(false)
        setShowCareers(false)
        setShowClientSubmit(false)
        setShowVendor(false)
        setDashboard(true)
    }

    useEffect(() => {
        if (new URLSearchParams(window.location.search).get('page') === 'newActivity') {
            handleNewEvent()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'existingActivity') {
            handleExistEvent()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'candidates') {
            handleShowCandidates()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'jobOrders') {
            handleShowJobOrder()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'jobOrderPipeline') {
            handleJobOrder()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'reports') {
            handleReports()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'settings') {
            handleSettings()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'company') {
            handleCompany()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'contact') {
            handleContact()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'list') {
            handleList()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'rcats-careers') {
            handleCareers()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'client-submit') {
            handleClientSubmit()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'vendor') {
            handleVendor()
        }
        if (new URLSearchParams(window.location.search).get('page') === 'dashboard') {
            handleDashboard()
        }
        // eslint-disable-next-line
    }, [new URLSearchParams(window.location.search).get('page')])


    return (
        <div id="main-wrapper">
            <div className='ndiv'><Navbar getAccess={(data) => setAccess(data)} /></div>
            <div ><button className="bi bi-list d-block d-sm-none ml-4 btn btn-sm btn-outline-dark" type="button" data-toggle="collapse" data-target="#navbarDashAltMarkup" aria-controls="navbarDashAltMarkup" aria-expanded="false" aria-label="Toggle navigation" onClick={handleNavCollapse}>
                <span > Menu</span>
            </button>
            </div>
            <div className={`ml-4 hdiv collapse ${!isNavCollapsed ? 'show' : ''} d-sm-block`} style={{ marginTop: '5%' }} id="navbarDashAltMarkup">
                <div className='col-12 row '>
                    <div className="dropdown ml-2 mbut">
                        <button onClick={() => {
                            history.push('/home?page=dashboard')
                            handleDashboard()
                            document.getElementById("navbarDashAltMarkup").classList.remove("show");
                        }} className={dashboard || new URLSearchParams(window.location.search).get('page') === 'dashboard' ? "btn btn-outline-dark active btn-sm" : "btn btn-outline-dark btn-sm "} type="button">
                            Dashboard
                        </button>
                    </div>

                    <div className="dropdown ml-2 mbut">
                        <button className={(logEvent || existEvents) || new URLSearchParams(window.location.search).get('page') === 'newActivity' ? "btn btn-outline-dark active btn-sm dropdown-toggle" : "btn btn-outline-dark btn-sm dropdown-toggle"} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Activity
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=newActivity')
                                handleNewEvent();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>New Activity</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=existingActivity')
                                handleExistEvent();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Existing Activity</label>
                        </div>
                    </div>
                    <div className="dropdown ml-2 mbut">
                        <button className={showCandidates || new URLSearchParams(window.location.search).get('page') === 'candidates' ? "btn btn-outline-dark active btn-sm dropdown-toggle" : "btn btn-outline-dark btn-sm dropdown-toggle"} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Candidates
                        </button>
                        <div className="dropdown-menu dropm" aria-labelledby="dropdownMenuButton">
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=candidates&type=add')
                                handleShowCandidates();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Add</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=candidates&type=view')
                                handleShowCandidates();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>View</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=candidates&type=search')
                                handleShowCandidates();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Search</label>
                        </div>
                    </div>
                    <div className="dropdown ml-2 mbut">
                        <button className={showJobOrder || new URLSearchParams(window.location.search).get('page') === 'jobOrders' ? "btn btn-outline-dark active btn-sm dropdown-toggle" : "btn btn-outline-dark btn-sm dropdown-toggle"} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Joborders
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=jobOrders&type=add')
                                handleShowJobOrder();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Add</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=jobOrders&type=view')
                                handleShowJobOrder();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>View</label>
                        </div>
                    </div>
                    <div className="dropdown ml-2 mbut">
                        <button className={jobOrder || new URLSearchParams(window.location.search).get('page') === 'jobOrderPipeline' ? "btn btn-outline-dark active btn-sm" : "btn btn-outline-dark btn-sm "} type="button" onClick={() => {
                            // handleJobOrder()
                            history.push('/home?page=jobOrderPipeline')
                            document.getElementById("navbarDashAltMarkup").classList.remove("show");
                        }}>
                            Pipeline
                        </button>
                    </div>
                    <div className="dropdown ml-2 mbut">
                        <button className={showCompany || new URLSearchParams(window.location.search).get('page') === 'company' ? "btn btn-outline-dark active btn-sm dropdown-toggle" : "btn btn-outline-dark btn-sm dropdown-toggle"} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Company
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=company&type=add')
                                handleCompany();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Add</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=company&type=view')
                                handleCompany();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>View</label>
                        </div>
                    </div>
                    <div className="dropdown ml-2 mbut">
                        <button className={showContact || new URLSearchParams(window.location.search).get('page') === 'contact' ? "btn btn-outline-dark active btn-sm dropdown-toggle" : "btn btn-outline-dark btn-sm dropdown-toggle"} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Contacts
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=contact&type=add')
                                handleContact();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Add</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=contact&type=view')
                                handleContact();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>View</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=contact&type=search')
                                handleContact();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Search</label>
                        </div>
                    </div>
                    <div className="dropdown ml-2 mbut">
                        <button className={showList || new URLSearchParams(window.location.search).get('page') === 'list' ? "btn btn-outline-dark active btn-sm dropdown-toggle" : "btn btn-outline-dark btn-sm dropdown-toggle"} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            List
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=list&type=view')
                                handleList();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>View</label>
                        </div>
                    </div>
                    <div className="dropdown ml-2 mbut ">
                        <button className={showReports || new URLSearchParams(window.location.search).get('page') === 'reports' ? "btn btn-outline-dark active btn-sm dropdown-toggle" : "btn btn-outline-dark btn-sm dropdown-toggle"} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Reports
                        </button>
                        <div className="dropdown-menu " aria-labelledby="dropdownMenuButton">
                            <label style={{ fontSize: '80%' }} className="dropdown-item " onClick={() => {
                                history.push('/home?page=reports&type=reports')
                                handleReports();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Recruiter</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item " onClick={() => {
                                history.push('/home?page=reports&type=candidate')
                                handleReports();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Candidate</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item " onClick={() => {
                                history.push('/home?page=reports&type=joborder')
                                handleReports();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Joborder</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item " onClick={() => {
                                history.push('/home?page=reports&type=pipeline')
                                handleReports();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Pipeline</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=reports&type=activity')
                                handleReports();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Activity</label>
                        </div>
                    </div>
                    <div className="dropdown ml-2 mbut">
                        <button className={showCareers || new URLSearchParams(window.location.search).get('page') === 'rcats-careers' ? "btn btn-outline-dark active btn-sm dropdown-toggle" : "btn btn-outline-dark btn-sm dropdown-toggle"} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Careers
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                history.push('/home?page=careers&type=view')
                                handleCareers();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Reports</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                window.open('/careers')
                            }}>Visit Page</label>
                        </div>
                    </div>
                    <div className="dropdown ml-2 mbut">
                        <button className={showClientSubmit || new URLSearchParams(window.location.search).get('page') === 'client-submit' ? "btn btn-outline-dark active btn-sm dropdown-toggle" : "btn btn-outline-dark btn-sm dropdown-toggle"} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Client
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                window.location.href = "/home?page=client-submit&type=submit"
                                handleClientSubmit();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Submit</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                window.location.href = "/home?page=client-submit&type=view"
                                handleClientSubmit();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>View</label>

                        </div>
                    </div>
                    <div className="dropdown ml-2 mbut">
                        <button className={showVendor || new URLSearchParams(window.location.search).get('page') === 'vendor' ? "btn btn-outline-dark active btn-sm dropdown-toggle" : "btn btn-outline-dark btn-sm dropdown-toggle"} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Vendor
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                window.location.href = "/home?page=vendor&type=add"
                                handleVendor();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>Add</label>
                            <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                window.location.href = "/home?page=vendor&type=view"
                                handleVendor();
                                document.getElementById("navbarDashAltMarkup").classList.remove("show");
                            }}>View</label>
                        </div>
                    </div>
                    {
                        access.access_level === 500 &&
                        <div className="dropdown ml-2 ">
                            <button className={showSettings || new URLSearchParams(window.location.search).get('page') === 'settings' ? "btn btn-outline-dark active btn-sm dropdown-toggle" : "btn btn-outline-dark btn-sm dropdown-toggle"} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Settings
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                    history.push('/home?page=settings&type=job_type_view')
                                    handleSettings();
                                    document.getElementById("navbarDashAltMarkup").classList.remove("show");
                                }}>Job Types</label>
                                <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                    history.push('/home?page=settings&type=resume')
                                    handleSettings();
                                    document.getElementById("navbarDashAltMarkup").classList.remove("show");
                                }}>Resume Access</label>
                                <label style={{ fontSize: '80%' }} className="dropdown-item" onClick={() => {
                                    history.push('/home?page=settings&type=merge')
                                    handleSettings();
                                    document.getElementById("navbarDashAltMarkup").classList.remove("show");
                                }}>Merge Users</label>
                            </div>
                        </div>
                    }


                </div>
                <div className="mt-3">
                    {!logEvent && message}
                </div>
            </div>
            <div style={{ minHeight: '65vh' }}>
                <Dashboard dashboard={dashboard || new URLSearchParams(window.location.search).get('page') === 'dashboard'} setDashboard={(data) => setDashboard(data)} access={access} />
                <CreateEvent access={access} logEvent={logEvent || new URLSearchParams(window.location.search).get('page') === 'newActivity'} getMessage={(data) => setMessage(data)} setEvent={() => setLogEvent(!logEvent)} />
                <ExistEvent existEvent={existEvents || new URLSearchParams(window.location.search).get('page') === 'existingActivity'} />
                <JobOrder jobOrder={jobOrder || new URLSearchParams(window.location.search).get('page') === 'jobOrderPipeline'} getMessage={(data) => setMessage(data)} setJobOrder={() => setJobOrder(false)} access={access} />
                <ViewJobOrder showJobOrder={showJobOrder || new URLSearchParams(window.location.search).get('page') === 'jobOrders'} getMessage={(data) => setMessage(data)} setShowJobOrder={() => setShowJobOrder(false)} access={access} />
                <ShowCandidates showCandidates={showCandidates || new URLSearchParams(window.location.search).get('page') === 'candidates'} access={access} getMessage={(data) => setMessage(data)} setShowCandidates={() => setShowCandidates(false)} />
                <ShowReports showReports={showReports || new URLSearchParams(window.location.search).get('page') === 'reports'} access={access} />
                <Settings showSettings={showSettings || new URLSearchParams(window.location.search).get('page') === 'settings'} access={access} />
                <Company showCompany={showCompany || new URLSearchParams(window.location.search).get('page') === 'company'} getMessage={(data) => setMessage(data)} setShowCompany={() => setShowCompany(false)} access={access} />
                <Contact showContact={showContact || new URLSearchParams(window.location.search).get('page') === 'contact'} getMessage={(data) => setMessage(data)} setShowContact={() => setShowContact(false)} access={access} />
                <List showList={showList || new URLSearchParams(window.location.search).get('page') === 'list'} getMessage={(data) => setMessage(data)} setShowList={() => setShowList(false)} access={access} />
                <CareerReports showCareers={showCareers || new URLSearchParams(window.location.search).get('page') === 'rcats-careers'} getMessage={(data) => setMessage(data)} setShowCareers={() => setShowCareers(false)} access={access} />
                <ClientSubmit showClientSubmit={showClientSubmit || new URLSearchParams(window.location.search).get('page') === 'client-submit'} getMessage={(data) => setMessage(data)} setShowClientSubmit={() => setShowClientSubmit(false)} access={access} />
                <Vendor showVendor={showVendor || new URLSearchParams(window.location.search).get('page') === 'vendor'} setShowVendor={() => setShowVendor(false)} access={access} />
            </div>
            <div className='footer'>
                <p style={{ fontSize: '10px', margin: '0px' }}>
                    Build Version {VERSION} Date {BUILD_DATE}
                </p>
                <p style={{ fontSize: '10px' }}>
                    © {new Date().getFullYear()} Novisync Inc.All Rights Reserved
                </p>
            </div>
        </div >
    )
}
